import { ru } from '@/i18n/ru';

export type DictionaryGroup = keyof typeof ru.dict.groups;

export interface CatalogEntry {
  slug: string;
  label: string;
  group: DictionaryGroup;
}

const n = ru.dict.names;

/** Dictionary pages under /dictionaries/<slug>, in menu order. */
export const DICTIONARY_CATALOG: readonly CatalogEntry[] = [
  { slug: 'staff', label: n.staff, group: 'people' },
  { slug: 'vehicles', label: n.vehicles, group: 'people' },
  { slug: 'devices', label: n.devices, group: 'people' },
  { slug: 'call-reasons', label: n.callReasons, group: 'medical' },
  { slug: 'call-places', label: n.callPlaces, group: 'medical' },
  { slug: 'report-templates', label: n.reportTemplates, group: 'medical' },
  { slug: 'hospitals', label: n.hospitals, group: 'medical' },
  { slug: 'icd10', label: n.icd10, group: 'medical' },
  { slug: 'services', label: n.services, group: 'prices' },
  { slug: 'transport-tariffs', label: n.transportTariffs, group: 'prices' },
  { slug: 'tariff-rules', label: n.tariffRules, group: 'prices' },
  { slug: 'holidays', label: n.holidays, group: 'prices' },
  { slug: 'expense-categories', label: n.expenseCategories, group: 'prices' },
  { slug: 'organizations', label: n.organizations, group: 'partners' },
  { slug: 'contracts', label: n.contracts, group: 'partners' },
  { slug: 'cancel-reasons', label: n.cancelReasons, group: 'other' },
  { slug: 'incident-types', label: n.incidentTypes, group: 'other' },
  { slug: 'users', label: n.users, group: 'other' },
];

export const DICTIONARY_GROUPS: readonly DictionaryGroup[] = [
  'people',
  'medical',
  'prices',
  'partners',
  'other',
];
